export type ExperimentalFeatureId =
  "ai-chat" | "ai-connections" | "connected-sources" | "notebooks" | "resource-redesign" | "system-redesign";

export type ExperimentalFeature = {
  readonly id: ExperimentalFeatureId;
  readonly storageKey: string;
  // Half-wired features stay invisible unless their id is listed in VITE_EXPERIMENTAL_AVAILABLE.
  readonly gated?: boolean;
};

// Insertion order drives the order of the rows on the Application Settings page.
export const EXPERIMENTAL_FEATURES: ExperimentalFeatureRegistry = {
  "system-redesign": {
    id: "system-redesign",
    storageKey: "istari-ff-system-redesign",
    gated: true,
  },
  "resource-redesign": {
    id: "resource-redesign",
    storageKey: "istari-ff-resource-redesign",
    gated: true,
  },
  notebooks: {
    id: "notebooks",
    storageKey: "istari-ff-notebooks",
  },
  "ai-chat": {
    id: "ai-chat",
    storageKey: "istari-ff-ai-chat",
  },
  "connected-sources": {
    id: "connected-sources",
    storageKey: "istari-ff-connected-sources",
  },
  // Needs registry-service ≥ the F25 connections release (PR #1472); stays invisible until an
  // environment lists it in VITE_EXPERIMENTAL_AVAILABLE.
  "ai-connections": {
    id: "ai-connections",
    storageKey: "istari-ff-ai-connections",
    gated: true,
  },
};

export const EXPERIMENTAL_FEATURE_LIST: readonly ExperimentalFeature[] = Object.values(EXPERIMENTAL_FEATURES);

// Pinning `id` to the key makes a copy-pasted entry a compile error rather than a lookup that
// silently resolves the wrong feature.
type ExperimentalFeatureRegistry = {
  readonly [K in ExperimentalFeatureId]: ExperimentalFeature & { readonly id: K };
};
